import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/apporb-web/frontend/src/app/providers.tsx");
